import React, { useState } from 'react';
import Chart from './Chart';
import ProductChart from './ProductChart';

function Piechart({ categoryChartData, productCountByCategory }) {

  return (
    <div className="reportmap reportmapanalysy">
      <div className="reportmap_1">
        <Chart categoryChartData={categoryChartData} />
        <ProductChart productCountByCategory={productCountByCategory} />
      </div>
    </div>
  );
}

export default Piechart;
